import { render, staticRenderFns } from "./DormitoryOccupancy.vue?vue&type=template&id=0d85454f&scoped=true"
import script from "./DormitoryOccupancy.vue?vue&type=script&lang=js"
export * from "./DormitoryOccupancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85454f",
  null
  
)

export default component.exports